export const USER_NOT_CONFIRMED_EXCEPTION = "UserNotConfirmedException";
export const NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException";
export const USER_NOT_FOUND_EXCEPTION = "UserNotFoundException";
export const INVALID_PARAMETER_EXCEPTION = "InvalidParameterException";
export const INVALID_PASSWORD_EXCEPTION = "InvalidPasswordException";
export const USERNAME_EXISTS_EXCEPTION = "UsernameExistsException";
export const CODE_MISMATCH_EXCEPTION = "CodeMismatchException";
export const LIMIT_EXCEEDED_EXCEPTION = "LimitExceededException";
export const USER_UNAUTHENTICATED_EXCEPTION = "UserUnAuthenticatedException";

export const SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER =
  "Sorry something went wrong! Please try again later.";
export const INVALID_CONFIRMATION_CODE =
  "Invalid confirmation code provided, please try again.";
export const PASSWORD_MUST_BE_AT_LEAST_8_CHARACTERS =
  "Password must be at least 8 characters in length.";
export const INCORRECT_USERNAME_OR_PASSWORD = "Incorrect username or password.";
export const ACCOUNT_WITH_EMAIL_ALREADY_EXISTS =
  "Account with this email already exists.";
export const NO_ACCOUNT_WITH_THIS_EMAIL =
  "No account found with this email address.";
export const UNCONFIRMED_EMAIL = `Email address on account is unconfirmed. Email <a href = "mailto: help@flashpcb.com">help@flashpcb.com</a> for assistance.`;
export const ATTEMPT_LIMIT_EXCEEDED =
  "Attempt limit exceeded, please try after some time.";
export const INCORRECT_CURRENT_PASSWORD = "Incorrect current password.";
export const INVALID_PHONE_NUMBER_FORMAT = "Invalid phone number format.";
export const FAILED_TO_SAVE_TO_S3 = "Failed to save to s3";
export const COULD_NOT_UPDATE_MARKDOWN = "Could not update markdown.";
export const USER_ALREADY_AUTHENTICATED_EXCEPTION =
  "UserAlreadyAuthenticatedException";
export const PASSKEY_AUTHENTICATION_CANCELED = "PasskeyAuthenticationCanceled";
